import makeSlice from '@web/slices/shoppingSubscription/sliceMaker'

const slice = makeSlice({})

export default slice.reducer

export const actions = slice.actions
